module.exports = __webpack_public_path__ + "static/government-cyber-attacks-19311b81ebc37adb1cac6d37fdc39443.jpg";